export const StoreIcon = ({ className }) => (<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g strokeWidth="1.5" stroke="#4C2116">
      <path d="M4 13v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6"/>
      <path d="M15 20v-2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v2M2 8v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V8M7 8v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V8M12 8v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V8M17 8v3a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V8M3.497 4.257A2 2 0 0 1 5.354 3h13.292a2 2 0 0 1 1.857 1.257L22 8H2l1.497-3.743Z"/>
    </g>
  </svg>);
